<template>
  <div class="client-list">
    <pageDialog width="800px" @changeDialogVisible="changeDialogVisible" :dialogVisible="dialogVisible" title="选择客户">
      <div class="main-content">
        <div class="left">
          <div class="search-wrap">
            <el-input prefix-icon="search" clearable @input="handleSearch" size="small" v-model="queryInfo.keyword" placeholder="输入关键字" />
          </div>
          <el-scrollbar height="520px" style="min-width: 380px;">
            <div class="clent-list">
              <el-checkbox v-for="item in memberInfoList" :key="item.userId" v-model="item.checked" @change="(val) => handleCheckChange(val, item)">
                <div class="user-item">
                  <div class="avatar">
                    <template v-if="item.userAva!='default_ava.png'">
                      <img :src="item.userAva" alt="">
                    </template>
                    <template v-else>
                      <img src="@/assets/img/main/base/default_avatar.png" alt="">
                    </template>
                  </div>
                  <div class="uname">
                    <div class="nick">{{item.userRealname}}</div>
                    <div class="phone">{{item.userMobile}}</div>
                  </div>
                </div>
              </el-checkbox>
            </div>
          </el-scrollbar>
          <el-pagination @current-change="handleCurrentChange" layout="prev, pager, next" :total="memberInfoCount" />
        </div>
        <div class="right">
          <div class="top-form">
            <div>已选客户({{ruleForm.checkList.length}})</div>
            <div @click="handleAllRemoveClick" class="remove">全部移除</div>
          </div>
          <el-scrollbar height="520px">
            <div class="opt-list">
              <template v-for="(item,index) in ruleForm.checkList" :key="item.userId">
                <div class="user-wrap">
                  <div class="user-item">
                    <div class="avatar">
                      <template v-if="item.userAva!='default_ava.png'">
                        <img :src="item.userAva" alt="">
                      </template>
                      <template v-else>
                        <img src="@/assets/img/main/base/default_avatar.png" alt="">
                      </template>
                    </div>
                    <div class="uname">
                      <div class="nick">{{item.userRealname}}</div>
                      <div class="phone">{{item.userMobile}}</div>
                    </div>
                  </div>
                  <div @click="handleRemoveClick(index)" class="remove">删除</div>
                </div>
              </template>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="save-btn">
        <el-button @click="handleSaveClick" size="small" type="primary">保存</el-button>
      </div>
    </pageDialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref, computed, nextTick, watch } from 'vue'
import pageDialog from '@/components/page-dialog/page-dialog.vue'
import { getUserList } from '@/service/main/customer'
import { COMPANY_ID } from '@/common/constant'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus'
import cache from '@/utils/cache'
import { debounce } from 'lodash'

export default defineComponent({
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    selectedUsers: {
      type: Array,
      default: () => [] // 修复默认值（原代码为false，改为空数组）
    },
  },
  components: {
    pageDialog
  },
  emits: ['changeDialogVisible', 'changeUser'],
  setup(props, { emit }) {
    const store = useStore()

    const changeDialogVisible = flag => {
      emit('changeDialogVisible', flag)
    }

    // 已选客户列表（右侧显示 + 回显数据源）
    const ruleForm = reactive({
      checkList: [],
      searchValue: ''
    })

    // 左侧客户列表（带checked状态，用于el-checkbox勾选）
    const memberInfoList = ref([])
    const memberInfoCount = ref(0)

    // 表格查询参数
    const queryInfo = reactive({
      companyId: COMPANY_ID,
      keyword: '',
      hascard: '',
      gender: '',
      level: '',
      regStartTime: '',
      regEndTime: '',
      shopid: '',
      regfrom: '',
      page: 1
    })
    /**
     * 核心方法：同步左侧el-checkbox勾选状态与ruleForm.checkList
     * 逻辑：遍历左侧客户列表，根据userId判断是否在已选列表中，设置item.checked
     */
    const syncCheckState = () => {
      if (memberInfoList.value.length === 0 || ruleForm.checkList.length === 0) {
        // 若已选列表为空，清空所有勾选
        memberInfoList.value.forEach(item => {
          item.checked = false
        })
        return
      }

      // 提取已选客户的userId集合（方便快速匹配）
      const selectedUserIds = ruleForm.checkList.map(user => user.userId)
      // 遍历左侧客户列表，设置勾选状态
      memberInfoList.value.forEach(item => {
        item.checked = selectedUserIds.includes(item.userId)
      })
    }


    // 1. 监听父组件传递的selectedUsers，同步到ruleForm.checkList并触发回显
    watch(() => props.selectedUsers, (newSelectedUsers) => {
      if (!newSelectedUsers) return
      // 同步已选客户到ruleForm（深拷贝避免引用问题）
      ruleForm.checkList = JSON.parse(JSON.stringify(newSelectedUsers))
      // 触发左侧复选框回显
      syncCheckState()
    }, { immediate: true, deep: true })

    // 2. 监听memberInfoList（左侧客户列表）加载完成，触发回显
    watch(memberInfoList, () => {
      nextTick(() => { // 等待DOM渲染完成
        syncCheckState()
      })
    }, { deep: true })

    // 3. 监听ruleForm.checkList变化（右侧删除/全部移除），同步左侧勾选状态
    watch(() => ruleForm.checkList, () => {
      syncCheckState()
    }, { deep: true })

    
    /**
     * 左侧复选框勾选/取消事件
     * @param {Boolean} val - 勾选状态（true=勾选，false=取消）
     * @param {Object} item - 当前勾选的客户对象
     */
    const handleCheckChange = (val, item) => {
      if (!val) {
        // 勾选：判断客户是否已在已选列表，避免重复添加
        const isExist = ruleForm.checkList.some(user => user.userId === item.userId)
        if (!isExist) {
          ruleForm.checkList.push({ ...item }) // 浅拷贝，避免引用关联
        }
        console.log(ruleForm.checkList);
        
      } else {
        // 取消勾选：从已选列表中移除该客户
        ruleForm.checkList = ruleForm.checkList.filter(user => user.userId !== item.userId)
      }
    }

    /**
     * 右侧删除单个客户
     */
    const handleRemoveClick = (index) => {
      ruleForm.checkList.splice(index, 1)
      // 同步左侧勾选状态（自动触发syncCheckState）
    }

    /**
     * 右侧全部移除
     */
    const handleAllRemoveClick = () => {
      ruleForm.checkList = []
      // 同步左侧勾选状态（自动触发syncCheckState）
    }

    /**
     * 分页切换
     */
    const handleCurrentChange = (page) => {
      queryInfo.page = page
      initPage()
    }

    /**
     * 搜索（防抖）
     */
    const handleSearch = debounce(() => {
      queryInfo.page = 1 // 搜索时重置为第一页
      initPage()
    }, 500)

    /**
     * 加载客户列表（左侧）
     */
    const initPage = async () => {
      const adminInfo = cache.getCache('adminInfo')
      const res = await getUserList({ ...queryInfo, userId: adminInfo.userId })
      // 为每个客户添加checked属性（默认false）
      memberInfoList.value = res.data.list.map(item => ({ ...item, checked: false }))
      memberInfoCount.value = res.data.total
      // 列表加载完成后，同步勾选状态（回显）
      nextTick(() => {
        syncCheckState()
      })
    }

    /**
     * 保存已选客户
     */
    const handleSaveClick = () => {
      const list = ruleForm.checkList
      if (list.length === 0) {
        ElMessage({
          message: '请选择客户！',
          type: 'warning',
        })
        return
      }
      emit('changeUser', list)
      changeDialogVisible(false)
    }

    // 初始化加载客户列表
    initPage()

    return {
      handleSearch,
      handleAllRemoveClick,
      handleCurrentChange,
      handleRemoveClick,
      handleSaveClick,
      handleCheckChange,
      memberInfoCount,
      memberInfoList,
      queryInfo,
      changeDialogVisible,
      COMPANY_ID,
      ruleForm,
    }
  }
})
</script>

<style scoped lang="less">
/* 原有样式保持不变 */
.client-list {
  .remove {
    cursor: pointer;
  }

  .user-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .remove {
      color: rgb(133, 88, 250);
      cursor: pointer;
    }
  }

  .save-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    position: relative;
    z-index: 1000;
  }

  .main-content {
    display: flex;
    min-height: 570px;

    &:deep(.el-checkbox) {
      display: inline-block;
      height: 55px;
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0 10px;
      &:hover {
        background-color: #f5f7fa;
      }
    }

    .user-item {
      display: flex;
      align-items: center;
      flex: 1;

      .uname {
        .nick {
          margin-bottom: 4px;
        }

        .phone {
          font-size: 12px;
          color: #999;
        }
      }

      img {
        width: 36px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }

    .left {
      border-right: 2px solid rgb(245, 245, 245);
      flex: 1.4;

      .search-wrap{
        margin-bottom:10px;
        padding-right: 10px;
      }
      &:deep(.el-scrollbar) {
        height: 530px;
      }

      &:deep(.el-pagination) {
        text-align: center !important;
        margin-top: 10px;
      }
    }

    .right {
      flex: 3;
      padding: 0 10px;

      .opt-list {
        .user-item {
          height: 55px;
        }
      }

      .top-form {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .remove {
          color: rgb(133, 88, 250);
        }
      }
    }
  }
}
</style>